module.exports = __webpack_public_path__ + "static/media/1_06.6eb56998.png";